import { render } from "./Know-About.vue?vue&type=template&id=57181504&scoped=true"
import script from "./Know-About.vue?vue&type=script&lang=js"
export * from "./Know-About.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=57181504&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57181504"]])

export default __exports__